import React, { useEffect, useState } from 'react';
import Table from '../ogComponent/table';
import Spinner from '../ogComponent/spinner';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import "./attendence.css";

export default function MyAttendence() {
  const [product, setProduct] = useState([]);
  const [employee, setEmployee] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectDate, setSelectDate] = useState(dayjs());
  const [currentPage, setCurrentPage] = useState(1);
  const userId = localStorage.getItem('userId');

  const header = [
    { name: 'Si No', label: '#', active: true },
    { name: 'Date', label: 'Punch Date', active: true },
    { name: 'Day', label: 'Day', active: true },
    { name: 'type', label: 'Direction', active: true },
    { name: 'time', label: 'Timestamp', active: true }
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    const fetchAttendanceData = async () => {
      try {
        setLoading(true);
        const formattedDate = selectDate.format('YYYY-MM-DD');

        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/single-attendance/`,
          {
            params: { punch_date: formattedDate, employee__id: userId },
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const attendanceData = response.data[0];

        if (attendanceData) {
          setEmployee(attendanceData.employee_details);
          const formattedPunchData = attendanceData.punch_details.map((punch, index) => ({
            "Si No": index + 1,
            Date: dayjs(attendanceData.punch_date).format('DD MMM YYYY'),
            Day: attendanceData.day,
            type: (
              <span className={`status-pill ${punch.punch_direction?.toUpperCase() === 'IN' || punch.punch_direction?.toLowerCase() === 'clock-in' ? 'status-active-pill' : 'status-inactive-pill'}`}>
                <span className="status-spot"></span>
                {punch.punch_direction}
              </span>
            ),
            time: <span className="fw-bold text-main">{punch.punch_time}</span>
          }));
          setProduct(formattedPunchData);
        } else {
          setProduct([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching attendance data:', error);
        setLoading(false);
        setProduct([]);
      }
    };

    fetchAttendanceData();
  }, [selectDate, userId]);

  if (loading) {
    return <div className="p-5 text-center"><Spinner /></div>;
  }

  return (
    <div className="AttendanceContainer w-100 h-100 px-4 pt-4 pb-5">
      <div className="attendance-header mb-4">
        <h3 className="m-0">Day Logs</h3>
        <p className="text-muted small mb-0">Detailed view of individual punch records for the selected date.</p>
      </div>

      <div className="attendance-filters">
        <div className="info-text-box">
          <p className="m-0 text-muted small fw-bold uppercase">EMPLOYEE</p>
          <h5 className="m-0 fw-bold text-main">{employee.Name || 'N/A'}</h5>
          <span className="text-muted small">{employee.Job_position} • {employee.Branch_name}</span>
        </div>

        <div className="date-picker-group">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select Date"
              value={selectDate}
              onChange={(newValue) => setSelectDate(newValue)}
              slotProps={{ textField: { size: 'small', sx: { width: 220 } } }}
            />
          </LocalizationProvider>
        </div>
      </div>

      <div className="attendance-table-wrapper">
        {product.length > 0 ? (
          <Table
            header={header}
            product={product}
            onRowClick={() => { }}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        ) : (
          <div className="empty-attendance">
            <img src="/assets/file.png" className="empty-img" alt="No data" />
            <p className="fw-semibold text-muted">No punch records found for this date.</p>
          </div>
        )}
      </div>
    </div>
  );
}
